export enum ConnectorCannotDeleteReason {
  ActiveCallPlanConfigurations = 'ActiveCallPlanConfigurations',
  ActiveCareConnectSubscriptions = 'ActiveCareConnectSubscriptions',
  ActivePersonalNumberRangeConfigurations = 'ActivePersonalNumberRangeConfigurations',
}
